import { STATISTICS_ENCODED_QUERY_KEY, getHashSearchParams } from './encodedUrlQuery';
import {
    areSearchParamsEqual,
    buildMonitoringSearchParams,
    parseMonitoringUrlState,
    MonitoringUrlWriteState,
} from './monitoringUrlState';

export { areSearchParamsEqual };

export function readInitialStatisticsUrlState() {
    return parseMonitoringUrlState(getHashSearchParams(), STATISTICS_ENCODED_QUERY_KEY);
}

export function buildStatisticsSearchParams(state: MonitoringUrlWriteState) {
    return buildMonitoringSearchParams(
        {
            ...state,
            writeCustomStartRangeOnly: true,
        },
        STATISTICS_ENCODED_QUERY_KEY
    );
}
